import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchQualityScoreCategoryIdStarted = () => {
  return {
    type: actionTypes.FETCH_QUALITY_SCORE_CATEGORY_ID_STARTED,
  };
};

export const fetchQualityScoreCategoryIdSuccess = (qualityScoreCategoryId) => {
  return {
    type: actionTypes.FETCH_QUALITY_SCORE_CATEGORY_ID_SUCCESS,
    qualityScoreCategoryId: qualityScoreCategoryId,
  };
};

export const fetchQualityScoreCategoryIdFailed = () => {
  return {
    type: actionTypes.FETCH_QUALITY_SCORE_CATEGORY_ID_FAILED,
  };
};

export const fetchQualityScoreCategoryId = (
  providerId: string,
  categoryId: string
) => {
  return (dispatch) => {
    dispatch(fetchQualityScoreCategoryIdStarted());
    axios
      .get(serverconfigs.fetchQualityScoreCategoriesUrl+`/${providerId}?categoryId=${categoryId}`)
      .then((response) => {
        console.log(response.data);
        dispatch(fetchQualityScoreCategoryIdSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchQualityScoreCategoryIdFailed());
      });
  };
};
